import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { ConfigProvider } from "antd";
import pt_BR from "antd/lib/locale-provider/pt_BR";
import moment from "moment";
import "moment/locale/pt-br";

moment.locale("pt-BR");
ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider locale={pt_BR}>
      <App />
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
